import * as Yup from 'yup'

export const schema = Yup.object().shape({
  tituloTCC: Yup.string().nullable()
})
